import React, {PropTypes as T} from 'react';
import Modal, {ModalHeader, ModalContent, ModalFooter} from '../../common/modal';
import Button from '../../common/button';
import TU from '../../common/tu';
import withDevice from '../../common/withDeviceHOC';
import SadTicketIcon from '../../common/icons/icon_sad_ticket';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';
import {translate} from '../../../utils/utils';

export class SeatmapPriceTypeLimitErrorModal extends React.Component {
  static propTypes = {
    translations: T.object,
    payload: T.shape({
      priceTypeName: T.string.isRequired
    }),
    onClose: T.func,
    isMobile: T.bool
  };

  static defaultProps = {
    onClose: Function.prototype
  };

  state = { isOpen: true };

  closeModal = () => {
    this.setState({ isOpen: false });
    setTimeout(this.props.onClose, 300);
  };

  render () {
    const trans = this.props.translations;
    const modalText = translate(
      trans.PRICE_TYPE_LIMIT_ERROR_INFO,
      {'%PRICE_TYPE_NAME%': `<b>${this.props.payload.priceTypeName}</b>`}
    );
    return (
      <Modal dataComponent="pricetype-limit-error-modal" isOpen={this.state.isOpen}>
        <ModalHeader isError>
          <div className="modal__header__icon__wrapper">
            <ModalCautionIcon className="modal__header__icon" />
          </div>
          <div className="modal__header_title">{trans.PRICE_TYPE_LIMIT_ERROR_HEADER}</div>
        </ModalHeader>
        <ModalContent>
          <SadTicketIcon className="modal__sad_ticket_icon" />
          <TU text={modalText} tag="div" />
          <TU text={trans.PRICE_TYPE_LIMIT_ERROR_INFO_LINE2} tag="div" />
        </ModalContent>
        <ModalFooter>
          <Button
            data-component="change-selection-button"
            primary
            onClick={this.closeModal}
            flex={this.props.isMobile}>{trans.CHANGE_SELECTION_BUTTON}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withDevice(SeatmapPriceTypeLimitErrorModal);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/pricetype_ticket_limit_error.js